import React, { Fragment } from "react";
import {
  List,
  Datagrid,
  Filter,
  EditButton,
  Button,
  TextInput,
  TextField,
  FunctionField,
  ShowButton,
  useRecordContext,
  Link,
  Pagination,
  TopToolbar,
  ChipField
} from "react-admin";
import BulkActiveButton from '../ConvertBuymotePoint/Action/Bulk.Active.Button';

// import BulkRejectButton from '../WithdrawRequest/Action/Bulk.Reject.Button';
import DownloadIcon from '@material-ui/icons/GetApp';
import { ConvertBuymotePointReqStatusSelectInput } from '../../UI/Input/SelectInput'

const PostPagination = () => <Pagination rowsPerPageOptions={[10, 25, 50, 100, 200, 300, 400, 500, 1000, 2000]} />;

const BulkActionButtons = ({ ...props }) => {

  return (<Fragment>
    <BulkActiveButton label="Bulck Active"  {...props} />
    {/* <BulkRejectButton label="Bulck Reject"  {...props} /> */}

  </Fragment>)
}
const ProfileidFiled = (props) => {
  const record = useRecordContext();
  return (
    <TextField {...props} component={Link} to={`/user?filter={"q":"${record.profile_id}"}`} onClick={(event) => event.stopPropagation()} />
  )
}



const ListFilter = (props) => (
  <Filter {...props}>
    <TextInput label="Search" source="q" alwaysOn />
    <ConvertBuymotePointReqStatusSelectInput label="Status" source="status" alwaysOn />
  </Filter>
);
////www.stage.tiruvannamalaiproperties.in/api/v1/1/customers/export?
const ListActions = () => (
  <TopToolbar>
    <Button href={'//sboportal.org.in/admin/api/v1/widthdraw/export?'} label="Export" ><DownloadIcon /></Button>
  </TopToolbar>
);

const ConvertBuymotePointList = ({ ...props }) => {

  return (
    <Fragment>
      <List
        {...props}

        title="Convert Buymote Point"
        filters={<ListFilter />}
        bulkActionButtons={<BulkActionButtons />}
        sort={{ field: "name", order: "ASC" }}
        // actions={<ListActions />}
        pagination={<PostPagination />}
      >
        <Datagrid >
          <TextField source="id" />
          <ProfileidFiled source="profile_id" label="Profile Id" />
          <TextField source="name" label="Name" />
          <TextField source="buymote_name" label="Buymote name" />
          <TextField source="total_amount" label="Point" />
          <TextField source="phone" label="Phone" />
          <TextField source="req_datetime" label="Request datet" />          
          <FunctionField source="req_status" label="Status" render={record => {
            if (record['req_status'] === 'Decline') {
              return (<Button style={{ color: 'red', border: '1px solid' }} label="Decline" size="small"></Button>)
            } else if (record['req_status'] === 'Pending') {
              return (<Button style={{ color: 'orange', border: '1px solid' }} label="Pending" size="small"></Button>)
            } else if (record['req_status'] === 'Sent') {
              return (<Button style={{ color: 'green', border: '1px solid' }} label="Sent" size="small"></Button>)
            }
          }} />
          <FunctionField source="req_status" label="Edit Action" render={record => {
            if (record['req_status'] === 'Pending') {
              return (<EditButton />)
            }

          }} />
          <ShowButton />
        </Datagrid>
      </List>

    </Fragment>
  );
};

export default ConvertBuymotePointList;
